<template>
  <SubpageTransition>
    <router-view />
  </SubpageTransition>
</template>

<script>
import SubpageTransition from "@/components/common-ui/transitions/subpage/index.vue";

export default {
  components: {
    SubpageTransition
  }
}
</script>
